import { motion } from "framer-motion";

export const Arch = ({ className = "", stroke = "var(--ink-soft)", sw = 1, opacity = 1, style, ...rest }) => (
  <svg viewBox="0 0 100 150" className={className} style={style} fill="none" aria-hidden="true" {...rest}>
    <path
      d="M6 148 V64 A44 44 0 0 1 94 64 V148"
      stroke={stroke}
      strokeWidth={sw}
      opacity={opacity}
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
    />
  </svg>
);

export const Traveler = ({ className = "", tone = "var(--ink-soft)", style, ...rest }) => (
  <svg viewBox="0 0 24 50" className={className} style={style} fill="none" aria-hidden="true" {...rest}>
    <circle cx="12" cy="6.5" r="4.4" fill={tone} />
    <path
      d="M12 13.5c-3.6 0-5.6 2.3-5.6 5.8V31h3l1.3 12.5h2.6L14.6 31h3V19.3c0-3.5-2-5.8-5.6-5.8Z"
      fill={tone}
    />
    <ellipse cx="12" cy="46.5" rx="6.4" ry="1.6" fill={tone} opacity="0.16" />
  </svg>
);

export const PulseGlow = ({ className = "", color = "var(--amber)", size = 10, style }) => (
  <span className={`th-pulse ${className}`} style={{ width: size, height: size, background: color, ...style }} />
);

export const Thread = ({
  d,
  progress,
  viewBox = "0 0 1000 400",
  stroke = "var(--ink-soft)",
  sw = 1.2,
  className = "",
  flow = false,
  opacity = 1,
}) => (
  <svg viewBox={viewBox} preserveAspectRatio="none" className={`pointer-events-none ${className}`} fill="none" aria-hidden="true">
    <motion.path
      d={d}
      stroke={stroke}
      strokeWidth={sw}
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      className={flow ? "th-thread-flow" : ""}
      style={progress ? { pathLength: progress, opacity } : { opacity }}
    />
  </svg>
);
